import React, { FunctionComponent } from 'react';

const HelpIcon: FunctionComponent<
  React.PropsWithChildren<{ color?: string; width?: string; height?: string }>
> = ({ color = 'black', width = '14px', height = '16px' }) => (
  <svg
    data-testid="help-icon"
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.333334 6.99992C0.333334 3.31992 3.32 0.333252 7 0.333252C10.68 0.333252 13.6667 3.31992 13.6667 6.99992C13.6667 
        10.6799 10.68 13.6666 7 13.6666C3.32 13.6666 0.333334 10.6799 0.333334 6.99992ZM7.66667 9.66659V10.9999H6.33333V9.66659H7.66667ZM7 
        12.3333C4.06 12.3333 1.66667 9.93992 1.66667 6.99992C1.66667 4.05992 4.06 1.66659 7 1.66659C9.94 1.66659 12.3333 4.05992 
        12.3333 6.99992C12.3333 9.93992 9.94 12.3333 7 12.3333ZM4.33333 5.66658C4.33333 4.19325 5.52667 2.99992 7 2.99992C8.47333 
        2.99992 9.66667 4.19325 9.66667 5.66658C9.66667 6.52186 9.13999 6.98213 8.62718 7.43028C8.14068 7.85543 7.66667 8.26967 
        7.66667 8.99992H6.33333C6.33333 7.78574 6.96141 7.30431 7.51363 6.88103C7.94682 6.54899 8.33333 6.25273 8.33333 5.66658C8.33333 
        4.93325 7.73333 4.33325 7 4.33325C6.26667 4.33325 5.66667 4.93325 5.66667 5.66658H4.33333Z"
      fill={color}
    />
  </svg>
);

export default HelpIcon;
